import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher } from '@systemeio/ui';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UseUserPlanInterface, tableFeatures } from 'modules/profile/user-plan/types/user-plan-interface';
import { isFeatureExceeded } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
export interface PricePlanFeaturesColumnProps {
  billingPeriod: BillingPeriodEnum;
  setBillingPeriod: React.Dispatch<React.SetStateAction<BillingPeriodEnum>>;
  data: UseUserPlanInterface;
}
const PricePlanFeaturesColumn = t0 => {
  const $ = _c(22);
  const {
    billingPeriod,
    setBillingPeriod,
    data
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.settings.user_plan.billing_period_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <b className="text-text-primary font-inter text-start text-lg">{t1}</b>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = billingPeriod === BillingPeriodEnum.annual;
  let t4;
  if ($[4] !== setBillingPeriod) {
    t4 = () => setBillingPeriod(_temp);
    $[4] = setBillingPeriod;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("dashboard.settings.user_plan.billing_period_label");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <CheckBoxSwitcher selected={t3} onChange={t4} label={t5} labelClassName="text-text-primary min-w-[90px] text-base leading-5" />;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <div className="mb-6 h-[150px]"><div className="flex h-[150px] flex-col gap-[23px] pl-4 pr-1 pt-2">{t2}{t6}</div></div>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== billingPeriod || $[16] !== data || $[17] !== t) {
    t8 = tableFeatures.map((column, index) => {
      const isExceeded = isFeatureExceeded(data, billingPeriod, column);
      return <React.Fragment key={`features-column-${column.key}`}><div className={twMerge("text-text-primary font-inter truncate px-4 text-left text-base font-medium", isExceeded && "text-danger")}>{t(column.title)}</div>{tableFeatures[index + 1] ? <hr className="border-fill-primary mr-0 border-solid lg:-mr-6" /> : <div />}</React.Fragment>;
    });
    $[15] = billingPeriod;
    $[16] = data;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="bg-brand-primary/5 my-[0.5px] flex w-1/2 flex-col gap-2 pt-10 lg:my-[1px] lg:grid lg:w-full">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default PricePlanFeaturesColumn;
function _temp(prev) {
  if (prev === BillingPeriodEnum.monthly) {
    return BillingPeriodEnum.annual;
  }
  return BillingPeriodEnum.monthly;
}